import { render, staticRenderFns } from "./PaySlip_list.vue?vue&type=template&id=61da052c&scoped=true&"
import script from "./PaySlip_list.vue?vue&type=script&lang=js&"
export * from "./PaySlip_list.vue?vue&type=script&lang=js&"
import style0 from "./PaySlip_list.vue?vue&type=style&index=0&id=61da052c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61da052c",
  null
  
)

export default component.exports